import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  }
  catch{
    return true;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const api = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (isTokenExpired(token)) {
      localStorage.removeItem('auth_token');
      setLoading(false);
      return;
    }
    axios.post(`${api}/authorization/me`, {},
      { 
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => setUser(res.data.user_phone))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [api]);

  const signOut = () => {
    localStorage.removeItem("auth_token");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, setUser, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}